<script>
import { BDropdownDivider } from "bootstrap-vue";

export default {
  extends: BDropdownDivider
};
</script>